/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetWidgetDataRequest,
  GetWidgetSettingsResponse,
  Result,
  UpdateWidgetRequest,
  WidgetResponse,
} from '../models/index';
import {
    GetWidgetDataRequestFromJSON,
    GetWidgetDataRequestToJSON,
    GetWidgetSettingsResponseFromJSON,
    GetWidgetSettingsResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    UpdateWidgetRequestFromJSON,
    UpdateWidgetRequestToJSON,
    WidgetResponseFromJSON,
    WidgetResponseToJSON,
} from '../models/index';

export interface ApiWidgetsDataPostRequest {
    getWidgetDataRequest: GetWidgetDataRequest;
    xTenantID?: number;
}

export interface ApiWidgetsSettingsGetRequest {
    xTenantID?: number;
}

export interface ApiWidgetsSettingsIdPutRequest {
    id: number;
    updateWidgetRequest: UpdateWidgetRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class WidgetsApi extends runtime.BaseAPI {

    /**
     * This endpoint retrieves the data for the specified widget keys. It is used by the dashboard to load the widget data. Not more than 5 keys should be requested at once.
     * Get widget data for the specified keys
     */
    async apiWidgetsDataPostRaw(requestParameters: ApiWidgetsDataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WidgetResponse>>> {
        if (requestParameters['getWidgetDataRequest'] == null) {
            throw new runtime.RequiredError(
                'getWidgetDataRequest',
                'Required parameter "getWidgetDataRequest" was null or undefined when calling apiWidgetsDataPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/widgets/data`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetWidgetDataRequestToJSON(requestParameters['getWidgetDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WidgetResponseFromJSON));
    }

    /**
     * This endpoint retrieves the data for the specified widget keys. It is used by the dashboard to load the widget data. Not more than 5 keys should be requested at once.
     * Get widget data for the specified keys
     */
    async apiWidgetsDataPost(requestParameters: ApiWidgetsDataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WidgetResponse>> {
        const response = await this.apiWidgetsDataPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint retrieves the widget settings for the current tenant. It is used by the dashboard to load the widget settings, such as which widgets are enabled and their configuration.
     * Get widget settings
     */
    async apiWidgetsSettingsGetRaw(requestParameters: ApiWidgetsSettingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetWidgetSettingsResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/widgets/settings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetWidgetSettingsResponseFromJSON));
    }

    /**
     * This endpoint retrieves the widget settings for the current tenant. It is used by the dashboard to load the widget settings, such as which widgets are enabled and their configuration.
     * Get widget settings
     */
    async apiWidgetsSettingsGet(requestParameters: ApiWidgetsSettingsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetWidgetSettingsResponse>> {
        const response = await this.apiWidgetsSettingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint updates a widget. It is used by the dashboard to update the widget settings, such as which widgets are enabled and their configuration.
     * Update widget
     */
    async apiWidgetsSettingsIdPutRaw(requestParameters: ApiWidgetsSettingsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiWidgetsSettingsIdPut().'
            );
        }

        if (requestParameters['updateWidgetRequest'] == null) {
            throw new runtime.RequiredError(
                'updateWidgetRequest',
                'Required parameter "updateWidgetRequest" was null or undefined when calling apiWidgetsSettingsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/widgets/settings/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWidgetRequestToJSON(requestParameters['updateWidgetRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint updates a widget. It is used by the dashboard to update the widget settings, such as which widgets are enabled and their configuration.
     * Update widget
     */
    async apiWidgetsSettingsIdPut(requestParameters: ApiWidgetsSettingsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiWidgetsSettingsIdPutRaw(requestParameters, initOverrides);
    }

}
